import { Flex, ProgressCircle } from '@adobe/react-spectrum';
import React from 'react';

const WithLoading = ({
  shouldRender,
  label,
  labelStyle,
  children,
  justifyContent = 'center',
  alignItems = 'center',
  ...rest
}) => {
  return shouldRender ? (
    children
  ) : (
    <Flex width="100%" justifyContent={justifyContent} alignItems={alignItems}>
      {label && <span style={labelStyle}>{label}</span>}
      <ProgressCircle {...rest} aria-label={label || 'Loading...'} />
    </Flex>
  );
};

export default WithLoading;
